module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  if( widget.getButtons()&&widget.getButtons().length) { 
    ; __append("\n    ")
    ;  for( var i=0; i<widget.getButtons().length; i++) { 
    ; __append("\n    ")
    ;  var button = widget.getButtons()[i] 
    ; __append("\n    <div class=\"gl-pointer button ")
    ; __append(escapeFn(button.float))
    ; __append("\"\n         name=\"")
    ; __append(escapeFn(button.name))
    ; __append("\"\n         title=\"")
    ; __append(escapeFn(button.title))
    ; __append("\"\n         on-click=\"")
    ; __append(escapeFn(button.onClick))
    ; __append("\"\n         ")
    ;  if(button.hidden){ 
    ; __append("style=\"display:none;\"")
    ;  } 
    ; __append(">")
    ; __append(escapeFn(button.html))
    ; __append(escapeFn(button.title))
    ; __append("</div>\n    ")
    ;  } 
    ; __append("\n")
    ;  } 
  }
  return __output.join("");

}